import type { ThemeOptions } from '@mui/material/styles';
import MHMLogo from '../../assets/logo-mhm.png';
import MHMNavbarLogo from '../../assets/logo.png';

declare module '@mui/material/styles' {
  interface Theme {
    assets: {
      logoURL: string;
      navbarLogoURL: string;
    };
  }

  interface ThemeOptions {
    assets?: {
      logoURL?: string;
      navbarLogoURL?: string;
    };
  }

  interface Palette {
    highlight: Palette['primary'];
    selectedDevice: Palette['primary'];
    link: Palette['primary'];
    disclaimer: Palette['primary'];
    rainfall: Palette['primary'];
    bench_height: Palette['primary'];
    pipe_diameter: Palette['primary'];
    highlightedBackground: Palette['background'];
    appBarText: Palette['primary'];
    appBarBackground: Palette['primary'];
  }

  interface PaletteOptions {
    highlight?: PaletteOptions['primary'];
    selectedDevice?: PaletteOptions['primary'];
    link?: PaletteOptions['primary'];
    disclaimer?: PaletteOptions['primary'];
    rainfall?: PaletteOptions['primary'];
    bench_height?: PaletteOptions['primary'];
    pipe_diameter?: PaletteOptions['primary'];
    highlightedBackground?: PaletteOptions['primary'];
    appBarText?: PaletteOptions['primary'];
    appBarBackground?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    highlight: true;
    appBarText: true;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    highlight: true;
    appBarText: true;
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    rainfall: true;
    bench_height: true;
    pipe_diameter: true;
    highlight: true;
  }
}

declare module '@mui/material/AppBar' {
  interface AppBarPropsColorOverrides {
    appBarBackground: true;
  }
}

export const defaultTheme: ThemeOptions = {
  assets: {
    logoURL: MHMLogo,
    navbarLogoURL: MHMNavbarLogo,
  },
  typography: {
    fontFamily: 'Ubuntu, sans-serif',
    h1: { fontSize: '1.8rem', fontWeight: 'bold' },
  },
  palette: {
    primary: {
      main: '#000099',
    },
    secondary: {
      main: '#000099',
    },
    text: {
      primary: '#000',
    },
    link: {
      main: '#800080',
    },
    disclaimer: {
      main: '#808080',
    },
    background: {
      default: '#e3eefa',
      paper: '#fff',
    },
    highlight: {
      main: '#fff',
      contrastText: '#000',
    },
    selectedDevice: {
      main: '#B42222',
    },
    error: {
      main: '#FF0000',
    },
    rainfall: {
      main: '#009900',
    },
    bench_height: {
      main: '#800080',
    },
    pipe_diameter: {
      main: '#A7B3AC',
    },
    highlightedBackground: {
      main: '#f1f1f1',
    },
    appBarBackground: {
      main: '#000099',
      light: '#000099',
      dark: '#000099',
      contrastText: '#000099',
    },
    appBarText: { main: '#fff' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '1.1rem',
          lineHeight: '26px',
          borderRadius: '5px',
        },
      },
      defaultProps: {
        disableElevation: true,
        variant: 'contained',
        color: 'primary',
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
        variant: 'contained',
        color: 'primary',
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          'borderRadius': '0px',
          '@media (min-width: 900px)': {
            borderRadius: '5px',
          },
        },
      },
      defaultProps: { elevation: 0 },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          'margin': 0,
          'maxHeight': '100%',
          '@media (min-width: 900px)': {
            maxHeight: 'calc(100% - 64px)',
            margin: '32px',
          },
        },
      },
    },
  },
};
